module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "profile-clinic section_pad"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "layout"
  }, [_c('aside', {
    staticClass: "sidebar layout__sidebar"
  }, [_c('div', {
    staticClass: "sidebar__avatar-wrap"
  }, [_c('user-avatar', {
    attrs: {
      "data": _vm.user,
      "setClass": 'sidebar__avatar'
    }
  })], 1), _vm._v(" "), _c('nav', {
    staticClass: "sidebar__menu"
  }, [_c('ul', {
    staticClass: "sidebar__list"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'Personal'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t- Сотрудники\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'Patients'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t- Пациенты\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'Profile',
        params: {
          profile: _vm.user._id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t- Профиль\n\t\t\t\t\t\t\t")])], 1), _vm._v(" "), _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('router-link', {
    staticClass: "sidebar__link",
    attrs: {
      "to": {
        name: 'ClinicVisits'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t- Записи\n\t\t\t\t\t\t\t")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "layout__box"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "sidebar__list-item"
  }, [_c('a', {
    staticClass: "sidebar__link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" - Клиника")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44513767"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Cabinet/Clinic/Main.vue
// module id = 607
// module chunks = 0